import { useMemo } from "react"

import {
    BASE_MAP_ID,
    Layer,
    ROADSIDE_LAYER,
    ROADSIDE_SOURCE,
    useOrderingLayers,
} from "@l2r-front/l2r-map"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useTheme } from "@l2r-front/l2r-ui"

import { getRoadsideLayerStyle } from "../../utils/getRoadsideConfig"

import { RoadsideSource } from "../RoadsideSource"


type RoadsideLayerProps = {
    mapId?: string,
}

export function RoadsideLayer(props: RoadsideLayerProps) {
    const {
        mapId = BASE_MAP_ID,
    } = props

    const { selectedLinearLocations } = useNetworksStateContext()
    const theme = useTheme()

    const roadsideLayerConfig = useMemo(() => {
        const selectedRoad = selectedLinearLocations?.[0].road
        return getRoadsideLayerStyle(theme, selectedRoad)
    }, [theme, selectedLinearLocations])

    useOrderingLayers([ROADSIDE_LAYER], mapId)

    return (
        <RoadsideSource
            id={ROADSIDE_SOURCE}
            type="geojson"
            tolerance={.001}
        >
            <Layer
                id={ROADSIDE_LAYER}
                {...roadsideLayerConfig}
            />
        </RoadsideSource>
    )
}
